import { Injectable } from '@angular/core';
import { collectionData, doc, updateDoc } from '@angular/fire/firestore';
import { collection, Firestore, orderBy, query, where } from '@angular/fire/firestore';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { NotificationResponse } from 'src/app/layout/notifications/notifications.types';

@Injectable({
  providedIn: 'root'
})
export class NotificationDataService {


  constructor(private firestore: Firestore) {
    // console.log('Firestore instance:', firestore); 
  }
  
  getUnreadCount(userCode: string): Observable<number> {
    const notificationsRef = collection(
      this.firestore,
      `userNotifications/${userCode}/notifications`
    );
  
    const q = query(
      notificationsRef,
      where('createdAt', '!=', null),
      orderBy('createdAt', 'desc')
    );
  
    return collectionData(q, { idField: 'id' }).pipe(
      map((data: any[]) => {
        return data.filter(notif => !notif.read).length;
      })
    );
  }
  

  getNotifications(userCode: string): Observable<NotificationResponse[]> {
    const notificationsRef = collection(
      this.firestore,
      `userNotifications/${userCode}/notifications`
    );
    
    const q = query(
      notificationsRef,
      where('createdAt', '!=', null),   // Only include docs with valid timestamps
      orderBy('createdAt', 'desc')      // Now sort them
    );
    // const q = query(notificationsRef);
  
    return collectionData(q, { idField: 'id' }) as Observable<NotificationResponse[]>;
  }

  markAsRead(userCode: string, notifId: string): Promise<void> {
    const notifRef = doc(
      this.firestore,
      `userNotifications/${userCode}/notifications/${notifId}`
    );
    return updateDoc(notifRef, { read: true });
  }
  
}
